export class StorageBase{

  static getItem(p_key){
    return window[this._storage_type].getItem(p_key);
  }

  static getItemAsJSON(p_key){
    return JSON.parse(this.getItem(p_key)) ?? {};
  }

  static setItem(p_key, p_value){

    if(Array.isArray(p_value) || typeof p_value === 'object')
      p_value = JSON.stringify(p_value);

    window[this._storage_type].setItem(p_key, p_value);
    return this;
  }
}


export class LocalStorage extends StorageBase{

  static constructor(){
    this._storage_type = 'localStorage';
    return this;
  }
}


export class SessionStorage extends StorageBase{

  static constructor(){
    this._storage_type = 'sessionStorage';
    return this;
  }
}

